import {Spinner} from '@primer/react'

export const LoadingFallback = () => {
  return (
    <div className="d-flex flex-column flex-items-center pr-py-3">
      <Spinner aria-label="Loading" />
    </div>
  )
}
